export default "__VITE_ASSET__CKjTpSdd__"